import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'url-polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'flexboxgrid/css/flexboxgrid.css';
import App from './components/containers/App/App';
import { applyMiddleware, createStore, compose } from 'redux';
import reducers from './reducers';
import thunkMiddleware from 'redux-thunk';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { messages } from './messages';

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');
  require('@formatjs/intl-pluralrules/locale-data/en');
  require('@formatjs/intl-pluralrules/locale-data/fr');
}

if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill');
  require('@formatjs/intl-relativetimeformat/locale-data/en');
  require('@formatjs/intl-pluralrules/locale-data/fr');
}

let store;

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  store = createStore(
    reducers,
    composeEnhancers(applyMiddleware(thunkMiddleware))
  );
} else {
  store = createStore(reducers, applyMiddleware(thunkMiddleware));
}

const root = ReactDOM.createRoot(document.getElementById('app'));

root.render(
  <Provider store={store}>
    <IntlProvider
      locale={navigator.language}
      messages={messages(navigator.language)}
    >
      <App />
    </IntlProvider>
  </Provider>
);
